import { IAddHouseholdMemberRequest, IStatus } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const addHouseholdMember = async (
    newMember: IAddHouseholdMemberRequest,
): Promise<IStatus<string>> => {
    return await fetchIStatus(
        '/api/patients/adult-household-member',
        'post',
        newMember,
    );
};
